import api from "../services/api";

export async function listBuilderTemplates() {
  const res = await api.get("/form-templates");
  return Array.isArray(res.data) ? res.data : [];
}

export async function getBuilderTemplate(id) {
  const res = await api.get(`/form-templates/${id}`);
  return res.data;
}

export async function listBuilderTemplateVersions(templateId) {
  const res = await api.get(`/form-templates/${templateId}/versions`);
  return Array.isArray(res.data) ? res.data : [];
}

export async function createBuilderTemplate(payload) {
  const res = await api.post("/templates", payload);
  return res.data;
}

export async function createBuilderTemplateDraftVersion(templateId, definition) {
  const res = await api.post(`/form-templates/${templateId}/versions`, {
    status: "draft",
    definition,
  });
  return res.data;
}
